import React from 'react';
import './HealthIndicator.css'; // Assuming you have a CSS file for styles

const HealthIndicator = ({ data }) => {
  const { ActivePercentage, InactivePercentage, NotDataPercentage } = data;
  
  return (
    <div className="health-indicator-wrapper">
      {NotDataPercentage > 0 && (
        <div 
        className="health-indicator-nodata" 
        style={{ height: `${NotDataPercentage}%` }} 
        title={`No data: ${NotDataPercentage}%`}
        />
      )}
        {InactivePercentage > 0 && (
          <div 
          className="health-indicator-downtime" 
          style={{ height: `${InactivePercentage}%` }}
          title={`Downtime: ${InactivePercentage}%`} 
          />
        )}
      {ActivePercentage > 0 && (
        <div 
        className="health-indicator-uptime" 
        style={{ height: `${ActivePercentage}%` }}
        title={`Uptime: ${ActivePercentage}%`} 
        />
      )}
    </div>
  );
};

export default HealthIndicator;